export default __webpack_public_path__ + "static/media/pdf-download.20d9e029.svg";